import FlagIconBy from './FlagIconBy';
import FlagIconDe from './FlagIconDe';
import FlagIconEs from './FlagIconEs';
import FlagIconFr from './FlagIconFr';
import FlagIconIe from './FlagIconIe';
import FlagIconKz from './FlagIconKz';
import FlagIconPl from './FlagIconPl';
import FlagIconRu from './FlagIconRu';
import FlagIconTr from './FlagIconTr';
import FlagIconUa from './FlagIconUa';
import FlagIconUk from './FlagIconUk';
import FlagIconUs from './FlagIconUs';
import { FlagIconUz } from './FlagIconUz';

export default {
  FlagIconRu,
  FlagIconUk,
  FlagIconUs,
  FlagIconUa,
  FlagIconTr,
  FlagIconEs,
  FlagIconKz,
  FlagIconDe,
  FlagIconIe,
  FlagIconPl,
  FlagIconBy,
  FlagIconFr,
  FlagIconUz,
};
